import { render, staticRenderFns } from "./SavedProperties.vue?vue&type=template&id=a2e9eaee"
import script from "./SavedProperties.vue?vue&type=script&lang=ts"
export * from "./SavedProperties.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports